import React from 'react';
import { ProgressCircle } from '@americanexpress/dls-react';
import styles from './loading.module.scss';
import Selectors from 'src/utils/selectors';
import LiteralsService from 'src/services/literals/LiteralsService';

export default function Loading({ lg, className }: { lg?: boolean; className?: string }): JSX.Element {
    return (
        <div
            className={`${styles.loading} ${className} ${lg ? styles.lg : ''}`}
            data-cy={Selectors.General.LOADING_INDICATOR}
        >
            <ProgressCircle label={LiteralsService.getLiteral('General.progressCircle')} />
        </div>
    );
}
